import { render, staticRenderFns } from "./aiPredictionList.vue?vue&type=template&id=756cd0c1&scoped=true&"
import script from "./aiPredictionList.vue?vue&type=script&lang=js&"
export * from "./aiPredictionList.vue?vue&type=script&lang=js&"
import style0 from "./aiPredictionList.vue?vue&type=style&index=0&id=756cd0c1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756cd0c1",
  null
  
)

export default component.exports